<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main-fluid";
import ExpedienteLista from "@components/ExpedienteLista";
import ExpedienteExtrato from "@components/ExpedienteExtrato";

export default {
  page: {
    title: "Atendimentos",
    meta: [
      {
        name: "description",
        content: appConfig.description
      }
    ]
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  components: {
    Layout,
    ExpedienteLista,    
    ExpedienteExtrato
  },
  data() {
    return {
      title: "Atendimentos",
      items: [
        {
          text: "Página inicial",
          href: "/"
        },
        {
          text: "Atendimentos",
          href: "/Atendimentos",
          active: true
        }
      ],
      visitedTabs: [0]
    };
  },
  methods: {
    onInput(value) {
      if (!this.visitedTabs.includes(value)) {
        this.visitedTabs.push(value);
      }
    },
    callNew() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          path: `/Expediente/Novo`,
          props: {
            editable: true
          }
        }
      );
    }
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <b-card no-body>
      <div
        class="atendimento-novo"
        v-if="user.perfil === 'Administrador' || user.perfil === 'Consultor'"
      >
        <b-button class="btn btn-icon" variant="primary" v-on:click="callNew()">
          Registrar atendimento
        </b-button>
      </div>

      <b-tabs card @input="onInput">
        <b-tab title="Expedientes" active>
          <b-card-text v-if="visitedTabs.includes(0)">
            <ExpedienteLista />
          </b-card-text>
        </b-tab>        
        <b-tab title="Extrato" v-if="user.perfil === 'Administrador' || user.perfil === 'Cliente' || user.perfil === 'Cliente-Administrador'">
          
          <b-card-text v-if="visitedTabs.includes(1)">
            <ExpedienteExtrato />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </Layout>
</template>
